import React from "react";
import { TooltipHover } from "components/designV2/tooltip/tooltip";
import { useTranslation } from "react-i18next";
import {
  PassBooleanControl,
  PassSettingSwitch,
  PassSettingSwitchThumb,
} from "./passSettingsV2.styled";
import { SubscriptionRestrictedSettings } from "./companySystemSettings.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

export const AutoAcceptAllGigsSetting: React.FC<{
  value: boolean;
  onChange: (v: boolean) => void;
  disabledReason?: string;
}> = ({ value, onChange, disabledReason }) => {
  const { t } = useTranslation();
  const isDisabled = disabledReason != null;

  const setting = (
    <SubscriptionRestrictedSettings
      $disabled={isDisabled}
      disabled={isDisabled}
    >
      <SystemSettingRow
        title={t("System.AutoAcceptTeamGigs")}
        description={t("System.AutoAcceptTeamGigsInfo")}
        controlVerticalAlign="center"
      >
        <PassBooleanControl>
          <PassSettingSwitch
            type="button"
            $active={value}
            aria-label={t("System.AutoAcceptTeamGigs")}
            aria-pressed={value}
            disabled={isDisabled}
            onClick={() => onChange(!value)}
          >
            <PassSettingSwitchThumb $active={value} />
          </PassSettingSwitch>
        </PassBooleanControl>
      </SystemSettingRow>
    </SubscriptionRestrictedSettings>
  );

  return disabledReason ? (
    <TooltipHover text={disabledReason} fullWidth>
      {setting}
    </TooltipHover>
  ) : (
    setting
  );
};
